import urls from '../constants/urls';
import { processRolePercentages } from '../utils/charts/helper';

export const DEFAULT_STATS_EMPTY = 'chartsAdmin/DEFAULT_STATS_EMPTY';
export const LOAD_DEFAULT_STATS_FAILED =
  'chartsAdmin/LOAD_DEFAULT_STATS_FAILED';
export const LOAD_DEFAULT_STATS_SUCCESS =
  'chartsAdmin/LOAD_DEFAULT_STATS_SUCCESS';
export const LOADING_DEFAULT_STATS = 'chartsAdmin/LOADING_DEFAULT_STATS';

export const DIRECTORY_VIEWS_EMPTY = 'chartsAdmin/DIRECTORY_VIEWS_EMPTY';
export const LOAD_DIRECTORY_VIEWS_FAILED =
  'chartsAdmin/LOAD_DIRECTORY_VIEWS_FAILED';
export const LOAD_DIRECTORY_VIEWS_SUCCESS =
  'chartsAdmin/LOAD_DIRECTORY_VIEWS_SUCCESS';
export const LOADING_DIRECTORY_VIEWS = 'chartsAdmin/LOADING_DIRECTORY_VIEWS';

export const LOAD_UNIQUE_DIRECTORY_VIEWS_FAILED =
  'chartsAdmin/LOAD_UNIQUE_DIRECTORY_VIEWS_FAILED';
export const LOAD_UNIQUE_DIRECTORY_VIEWS_SUCCESS =
  'chartsAdmin/LOAD_UNIQUE_DIRECTORY_VIEWS_SUCCESS';
export const LOADING_UNIQUE_DIRECTORY_VIEWS =
  'chartsAdmin/LOADING_UNIQUE_DIRECTORY_VIEWS';
export const UNIQUE_DIRECTORY_VIEWS_EMPTY =
  'chartsAdmin/UNIQUE_DIRECTORY_VIEWS_EMPTY';

export const LOAD_ROLES_FAILED = 'chartsAdmin/LOAD_ROLES_FAILED';
export const LOAD_ROLES_SUCCESS = 'chartsAdmin/LOAD_ROLES_SUCCESS';
export const LOADING_ROLES = 'chartsAdmin/LOADING_ROLES';
export const ROLES_EMPTY = 'chartsAdmin/ROLES_EMPTY';

export const LOAD_ROLES_PERCENTAGE_FAILED =
  'chartsAdmin/LOAD_ROLES_PERCENTAGE_FAILED';
export const LOAD_ROLES_PERCENTAGE_SUCCESS =
  'chartsAdmin/LOAD_ROLES_PERCENTAGE_SUCCESS';
export const LOADING_ROLES_PERCENTAGE = 'chartsAdmin/LOADING_ROLES_PERCENTAGE';
export const ROLES_PERCENTAGE_EMPTY = 'chartsAdmin/ROLES_PERCENTAGE_EMPTY';

export const LOAD_SIGNUPS_FAILED = 'chartsAdmin/LOAD_SIGNUPS_FAILED';
export const LOAD_SIGNUPS_SUCCESS = 'chartsAdmin/LOAD_SIGNUPS_SUCCESS';
export const LOADING_SIGNUPS = 'chartsAdmin/LOADING_SIGNUPS';
export const SIGNUPS_EMPTY = 'chartsAdmin/SIGNUPS_EMPTY';

export const LOADING_CHARTS_ADMIN_DATA =
  'chartsAdmin/LOADING_CHARTS_ADMIN_DATA';
export const LOAD_CHARTS_ADMIN_DATA_SUCCESS =
  'chartsAdmin/LOAD_CHARTS_ADMIN_DATA_SUCCESS';
export const LOAD_CHARTS_ADMIN_DATA_FAILED =
  'chartsAdmin/LOAD_CHARTS_ADMIN_DATA_FAILED';

const initialState = {
  defaultStats: {},
  directoryViews: {},
  roles: {},
  rolesPercentage: {},
  signups: {},
  uniqueDirectoryViews: {},

  failedLoadingDefaultStats: false,
  failedLoadingDirectoryViews: false,
  failedLoadingRoles: false,
  failedLoadingRolesPercentage: false,
  failedLoadingSignups: false,
  failedLoadingUniqueDirectoryViews: false,

  isLoadingDefaultStats: false,
  isLoadingRoles: false,
  isLoadingRolesPercentage: false,
  isLoadingSignups: false,
  isLoadingUniqueDirectoryViews: false,

  defaultStatsEmpty: false,
  directoryViewsEmpty: false,
  rolesPercentageEmpty: false,
  signupsEmpty: false,
  uniqueDirectoryViewsEmpty: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DEFAULT_STATS:
      return {
        ...state,
        isLoadingDefaultStats: true,
        failedLoadingDefaultStats: false,
      };

    case LOAD_DEFAULT_STATS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingDefaultStats: false,
          failedLoadingDefaultStats: false,
          defaultStats: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingDefaultStats: false,
          defaultStatsEmpty: true,
        };
      }

    case LOAD_DEFAULT_STATS_FAILED:
      return {
        ...state,
        isLoadingDefaultStats: false,
        failedLoadingDefaultStats: true,
      };

    case LOADING_DIRECTORY_VIEWS:
      return {
        ...state,
        isLoadingDirectoryViews: true,
        failedLoadingDirectoryViews: false,
      };

    case LOAD_DIRECTORY_VIEWS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingDirectoryViews: false,
          failedLoadingDirectoryViews: false,
          directoryViews: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingDirectoryViews: false,
          directoryViewsEmpty: true,
        };
      }

    case LOAD_DIRECTORY_VIEWS_FAILED:
      return {
        ...state,
        isLoadingDirectoryViews: false,
        failedLoadingDirectoryViews: true,
      };

    case LOADING_UNIQUE_DIRECTORY_VIEWS:
      return {
        ...state,
        isLoadingDirectoryViews: true,
        failedLoadingDirectoryViews: false,
      };

    case LOAD_UNIQUE_DIRECTORY_VIEWS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingUniqueDirectoryViews: false,
          failedLoadingUniqueDirectoryViews: false,
          uniqueDirectoryViews: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingUniqueDirectoryViews: false,
          uniqueDirectoryViewsEmpty: true,
        };
      }

    case LOAD_UNIQUE_DIRECTORY_VIEWS_FAILED:
      return {
        ...state,
        isLoadingUniqueDirectoryViews: false,
        failedLoadingUniqueDirectoryViews: true,
      };

    case LOADING_ROLES:
      return {
        ...state,
        isLoadingRoles: true,
        failedLoadingRoles: false,
        isLoadingRolesPercentage: true,
        failedLoadingRolesPercentage: false,
      };

    case LOAD_ROLES_SUCCESS:
      if (action.payload.data) {
        const roles = action.payload.data;
        const rolesPercentage = processRolePercentages(roles);

        return {
          ...state,
          isLoadingRoles: false,
          failedLoadingRoles: false,
          isLoadingRolesPercentage: false,
          failedLoadingRolesPercentage: false,
          roles,
          rolesPercentage,
        };
      } else {
        return {
          ...state,
          isLoadingRoles: false,
          rolesEmpty: true,
          isLoadingRolesPercentage: true,
          rolesPercentageEmpty: true,
        };
      }

    case LOAD_ROLES_FAILED:
      return {
        ...state,
        isLoadingRoles: false,
        failedLoadingRoles: true,
        isLoadingRolesPercentage: false,
        failedLoadingRolesPercentage: true,
      };

    case ROLES_EMPTY:
      return {
        ...state,
        isLoadingRoles: false,
        rolesEmpty: true,
      };

    case LOADING_SIGNUPS:
      return {
        ...state,
        isLoadingSignups: true,
        failedLoadingSignups: false,
      };

    case LOAD_SIGNUPS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingSignups: false,
          failedLoadingSignups: false,
          signups: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingSignups: false,
          signupsEmpty: true,
        };
      }

    case LOAD_SIGNUPS_FAILED:
      return {
        ...state,
        isLoadingSignups: false,
        failedLoadingSignups: true,
      };

    case LOADING_CHARTS_ADMIN_DATA:
      return {
        ...state,
        isLoadingSignups: true,
        failedLoadingSignups: false,
        isLoadingDefaultStats: true,
        failedLoadingDefaultStats: false,
        isLoadingUniqueDirectoryViews: true,
        failedLoadingUniqueDirectoryViews: false,
      };

    case LOAD_CHARTS_ADMIN_DATA_SUCCESS:
      if (action.payload.data) {
        const { data } = action.payload.data;
        const { signup_trend, defaulting_trend, directory_view_trend } = data;

        return {
          ...state,
          isLoadingSignups: false,
          failedLoadingSignups: false,
          isLoadingDefaultStats: false,
          failedLoadingDefaultStats: false,
          isLoadingDirectoryViews: false,
          failedLoadingDirectoryViews: false,
          signups: signup_trend,
          directoryViews: directory_view_trend,
          defaultStats: defaulting_trend,
        };
      } else {
        return {
          ...state,
          isLoadingSignups: false,
          signupsEmpty: true,
          isLoadingDirectoryViews: false,
          directoryViewsEmpty: true,
          isLoadingDefaultStats: false,
          defaultStatsEmpty: true,
        };
      }

    case LOAD_CHARTS_ADMIN_DATA_FAILED:
      return {
        ...state,
        isLoadingSignups: false,
        failedLoadingSignups: true,
        isLoadingDefaultStats: false,
        failedLoadingDefaultStats: true,
        isLoadingUniqueDirectoryViews: false,
        failedLoadingUniqueDirectoryViews: true,
      };

    default:
      return state;
  }
};

export const loadUniqueDirectoryViews = hospitalId => dispatch => {
  return dispatch({
    types: [
      LOADING_UNIQUE_DIRECTORY_VIEWS,
      LOAD_UNIQUE_DIRECTORY_VIEWS_SUCCESS,
      LOAD_UNIQUE_DIRECTORY_VIEWS_FAILED,
    ],
    payload: {
      request: {
        url: urls.charts.directoryViews,
        params: { unique: true },
      },
    },
  });
};

export const loadChartsData = () => dispatch => {
  return dispatch({
    types: [
      LOADING_CHARTS_ADMIN_DATA,
      LOAD_CHARTS_ADMIN_DATA_SUCCESS,
      LOAD_CHARTS_ADMIN_DATA_FAILED,
    ],
    payload: {
      request: {
        url: urls.charts.v3.data,
      },
    },
  });
};

export const loadRoles = hospitalId => dispatch => {
  return dispatch({
    types: [LOADING_ROLES, LOAD_ROLES_SUCCESS, LOAD_ROLES_FAILED],
    payload: {
      request: {
        url: urls.charts.roles,
      },
    },
  });
};
